import { ConfirmationModal } from './ConfirmationModal';
import { Draggable } from './Draggable';
import { FrequenciesGraphicManager } from './FrequenciesGraphicManager';

class SdrReceiver extends Draggable
{
  constructor(parent_element, title = '')
  {
    super();

    const template_element = document.querySelector('.sdr-receiver--template');
    this.container_element = template_element.cloneNode(true);
    this.container_element.classList.remove('sdr-receiver--template');
    this.container_element.classList.remove('hidden');

    this.frequencies_graphic_manager = new FrequenciesGraphicManager(this.container_element);
    this.frequencies_graphic_manager.start();

    this.parent_element = parent_element;
    this.parent_element.appendChild(this.container_element);

    this.id = this.random_alphanumeric_id();
    this.title_element = this.container_element.querySelector('.sdr-receiver__title');
    this.title_element.innerHTML = title !== '' ? title : `Receiver '${this.id}'`;
    this.title_element.title = `Receiver '${this.id}'`;
    this.title_input_element = this.container_element.querySelector('.sdr-receiver__title-input');
    this.title_input_element.value = `Receiver '${this.id}'`;

    this.edit_title_button = this.container_element.querySelector('.sdr-receiver__edit-title');
    this.edit_title_button.addEventListener('click', this.start_edit_title.bind(this));
    this.accept_title_button = this.container_element.querySelector('.sdr-receiver__accept-title');
    this.accept_title_button.addEventListener('click', this.accept_edit_title.bind(this));

    this.close_button = this.container_element.querySelector('.sdr-receiver__remove-button');

    this.start(this.container_element);

    this.confirmation_modal = ConfirmationModal;
  }

  random_alphanumeric_id(length = 5)
  {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

  set_remove_callback(callback)
  {
    this.remove_callback = callback;
    this.close_button.addEventListener('click', this.show_confirmation_modal.bind(this));
  }

  show_confirmation_modal()
  {
    this.confirmation_modal.show({
      title: 'Remove Receiver',
      body: 'Are you sure you want to remove this receiver?',
      confirm_button_text: 'Remove',
      cancel_button_text: 'Cancel',
      on_confirm: this.remove.bind(this),
      on_cancel: () =>
      {}
    });
  }

  remove()
  {
    if (this.detached)
    {
      this.snap_to_parent();
    }
    this.parent_element.removeChild(this.container_element);
    this.remove_callback(this);
  }

  start_edit_title()
  {
    this.title_input_element.classList.remove('hidden');
    this.title_element.classList.add('sdr-receiver__title--editing');
    this.edit_title_button.classList.add('hidden');
    this.accept_title_button.classList.remove('hidden');
  }

  accept_edit_title()
  {
    this.title_element.innerHTML = this.title_input_element.value;
    this.title_element.title = this.title_input_element.value;
    this.title_input_element.classList.add('hidden');
    this.title_element.classList.remove('sdr-receiver__title--editing');
    this.edit_title_button.classList.remove('hidden');
    this.accept_title_button.classList.add('hidden');
  }
}

export { SdrReceiver };
